module.exports = __webpack_public_path__ + "img/product11-duanxin.68f64158.svg";